import { FC } from "react"
import { useTranslation } from "react-i18next"
import { resolveItemImage } from "@/helpers/itemImage"
import styles from "./SlotPicker.module.scss"
import { ISlotPickerProps } from "./types"

export const SlotPicker: FC<ISlotPickerProps> = ({ view, busy, onPick }) => {
  const { t } = useTranslation("inventory")
  return (
    <div className={styles.SlotPicker}>
      <p className={styles.SlotPicker_heading}>{t("belt.pickSlot")}</p>
      <div
        className={styles.SlotPicker_cells}
        style={{ gridTemplateColumns: `repeat(${view.length}, 1fr)` }}
      >
        {view.map((cell, index) => {
          const image = cell ? resolveItemImage(cell.definitionCode) : undefined
          return (
            <button
              key={index}
              type="button"
              className={styles.SlotPicker_cell}
              disabled={busy}
              onClick={() => onPick(index)}
            >
              {cell &&
                (image ? (
                  <img
                    src={image}
                    alt={t(`item.${cell.definitionCode}.name`)}
                  />
                ) : (
                  <span className={styles.SlotPicker_fallback} />
                ))}
            </button>
          )
        })}
      </div>
    </div>
  )
}
